import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Formik, Field } from 'formik';
import { Mutation } from 'react-apollo';
import Select from 'react-select';
import { UPDATE_ER_CHARGE_STATUS } from '../queries';
import { displaySuccess, displayError } from '../utilities';
import isEmpty from 'lodash/isEmpty';
import { erChargesGroupOptions } from '../constants';

const styles = {
  formContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    gridRowGap: '0.8rem',
    alignItems: 'center'
  },
  spans2: { gridColumn: '1 / span 2' },
  buttonRow: {
    gridColumn: '1 / span 2',
    textAlign: 'right',
    marginTop: '0.5rem'
  }
};

const defaultInitValue = {
  id: '',
  name: '',
  siteCode: '',
  itemGroup: '',
  itemCode: '',
  amount: '',
  isEnabled: false
};

const SelectInput = ({ field, form, options }) => {
  const favorableValue = options.find(o => o.value === field.value);
  return (
    <div style={{ width: '100%' }}>
      <Select
        value={favorableValue || null}
        onChange={option => {
          form.setFieldValue(field.name, option ? option.value : '');
        }}
        options={options}
        isClearable
        placeholder="Select Group"
      />
    </div>
  );
};

SelectInput.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired
};

const ERChargeModal = props => {
  const { chargeDetails, isOpen, hideModal, onSave } = props;
  let chargeDataEdit = isEmpty(chargeDetails)
    ? { ...defaultInitValue }
    : chargeDetails;
  let id = chargeDataEdit.id;

  return (
    <Mutation
      mutation={UPDATE_ER_CHARGE_STATUS}
      onCompleted={data => {
        onSave(data);
        displaySuccess('ER Charge updated');
      }}
      onError={e => displayError(e)}
      refetchQueries={() => ['GET_ER_CHARGES']}
    >
      {(updateStatus, { loading }) => {
        return (
          <Modal isOpen={isOpen} toggle={hideModal}>
            <ModalHeader toggle={hideModal}>
              {id ? 'Edit ER Charge Data' : 'Create New ER Charge Data'}
            </ModalHeader>
            <ModalBody>
              <div>
                <Formik
                  enableReinitialize
                  initialValues={chargeDataEdit}
                  validate={values => {
                    const errors = {};
                    if (values.isEnabled && !values.itemGroup) {
                      errors.isEnabled =
                        'Select a group to enable the ER charge.';
                    }
                    return errors;
                  }}
                  onSubmit={values => {
                    if (id) {
                      updateStatus({
                        variables: {
                          input: {
                            id: values.id,
                            itemGroup: values.itemGroup || null,
                            isEnabled: !!values.isEnabled
                          }
                        }
                      });
                    }
                  }}
                >
                  {formik => (
                    <div style={styles.formContainer}>
                      {formik.errors.isEnabled && (
                        <div style={styles.spans2} className="error">
                          {formik.errors.isEnabled}
                        </div>
                      )}
                      <div>Name</div>
                      <div>
                        <Field
                          name="name"
                          style={{ width: '100%', cursor: 'not-allowed' }}
                          disabled={true}
                        />
                      </div>
                      <div>SiteCode</div>
                      <div>
                        <Field
                          name="siteCode"
                          style={{ width: '100%', cursor: 'not-allowed' }}
                          disabled={true}
                        />
                      </div>
                      <div>Amount</div>
                      <div>
                        <Field
                          name="amount"
                          style={{ width: '100%', cursor: 'not-allowed' }}
                          disabled={true}
                        />
                      </div>

                      <div>Group</div>
                      <div>
                        <Field
                          name="itemGroup"
                          render={({ field, form }) => (
                            <SelectInput
                              field={field}
                              form={form}
                              options={erChargesGroupOptions}
                            />
                          )}
                        />
                      </div>

                      <div>Enable</div>
                      <div>
                        <Field
                          type="checkbox"
                          name="isEnabled"
                          checked={formik.values.isEnabled}
                        />
                      </div>
                      <div style={styles.buttonRow}>
                        <Button
                          onClick={formik.submitForm}
                          size="sm"
                          color="primary"
                          disabled={loading}
                        >
                          Update
                        </Button>
                      </div>
                    </div>
                  )}
                </Formik>
              </div>
            </ModalBody>
          </Modal>
        );
      }}
    </Mutation>
  );
};

ERChargeModal.propTypes = {
  chargeDetails: PropTypes.object,
  hideModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onSave: PropTypes.func.isRequired
};

export default ERChargeModal;
